<table class="ir-plugin-table" style="margin-bottom: 10px">
  <tr>
    <td>
      <span>
        <strong>{{ 'plugins.installationanilox.anilox-number' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationanilox.supplier' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationanilox.volume' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationanilox.angle' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationanilox.screen' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationanilox.delivered-prior' | translate }}</strong>
      </span>
    </td>
  </tr>

  <tr *ngFor="let item of anilox">
    <td>
      <p>
        <span>{{ item.AniloxNumber }}</span>
      </p>
    </td>
    <td>
      <p>
        <span>{{ item.Supplier }}</span>
      </p>
    </td>
    <td>
      <p>
        <span>{{ item.Volume }}</span>
      </p>
    </td>
    <td>
      <p>
        <span>{{ item.Angle }}</span>
      </p>
    </td>
    <td>
      <p>
        <span>{{ item.Screen }}</span>
      </p>
    </td>
    <td>
      <p>
        <span *ngIf="item.DeliveredPrior === true">
          {{ 'plugins.response.boolean.true' | translate }}
        </span>
        <span *ngIf="item.DeliveredPrior === false">
          {{ 'plugins.response.boolean.false' | translate }}
        </span>
      </p>
    </td>
  </tr>
</table>
